<script lang="js" setup>
import { useLocalePath } from '#imports'
import { useClipboard } from '@vueuse/core'
import { useUserStore } from '~/store/user'
import CopyText from './CopyText.vue'
import Logo from '@/assets/images/common/icon-logo-qr-white.svg?url'

const props = defineProps({
  overview: {
    type: Object,
    default: () => ({}),
  },
})

const { t } = useI18n()
const localePath = useLocalePath()
const user = useUserStore()
const { copy } = useClipboard()
const message = useMessage()
const referralLink = computed(() => {
  const path = localePath(`/sign-up?invitCode=${user.info.sharecode}`)
  if (import.meta.client) {
    return location.origin + path
  }
})
const os = computed(() => {
  const { overview } = props
  return [
    {
      text: t('累计返佣奖励(USDT)'),
      value: overview.totalRward ?? '-',
    },
    {
      text: t('累计邀请人数(人)'),
      value: overview.totalCount ?? '-',
    },
    {
      text: t('昨日返佣奖励(USDT)'),
      value: overview.yesterdayRward ?? '-',
    },
    {
      text: t('昨日邀请人数(人)'),
      value: overview.yesterdayCount ?? '-',
    },
  ]
})
const downloadLink = computed(() => {
  const path = localePath(`/download`)
  if (import.meta.client) {
    return location.origin + path
  }
})

function copyLink() {
  copy(referralLink.value)
  message.success(t('邀请链接复制成功'))
}
</script>

<template>
  <div class="py-10 flex justify-between gap-[30px]">
    <dl class="flex flex-wrap w-1/2 gap-2">
      <dt class="w-full text-2xl font-medium mb-10">
        {{ $t('数据总览') }}
      </dt>
      <dd v-for="(i, index) in os" :key="index" class="w-[calc((100%-8px)/2)]">
        <div class="font-bold text-[40px]">
          {{ i.value }}
        </div>
        <div class="text-textSecondary mt-4">
          {{ i.text }}
        </div>
      </dd>
    </dl>
    <div class="w-1/2 border border-border p-6 rounded-2xl">
      <div class="text-2xl font-medium mb-4">
        {{ t('专属邀请方式') }}
      </div>
      <CopyText :value="user.info?.sharecode || '-'">
        {{ t('邀请码') }}
      </CopyText>
      <CopyText :value="referralLink" class="mt-4">
        {{ t('邀请链接') }}
        <template #value>
          <div class="w-[300px] whitespace-nowrap overflow-hidden text-ellipsis">
            {{ referralLink ?? '-' }}
          </div>
        </template>
      </CopyText>
      <div class="flex justify-between gap-4 mt-4">
        <CommonXButton class="h-14 flex-1" @click="copyLink">
          {{ t('立即邀请') }}
        </CommonXButton>
        <CommonXTipsSimple content-class="!rounded-xl !p-4">
          <template #content>
            <div class="text-center">
              <div class="w-[210px] h-[210px] p-3 bg-pageTertiary rounded-xl">
                <CommonXQRCode :url="downloadLink" :logo="Logo" log-class="w-10 h-10" />
              </div>

              <div class="text-sm font-medium mt-4">
                {{ t('下载APP') }}
              </div>
            </div>
          </template>
          <CommonXButton type="default" class="h-14 flex-shrink-0 !px-8">
            <img src="@/assets/images/referral/ic-qr-code.svg?url" class="h-8 w-8 text-textPrimary">
          </CommonXButton>
        </CommonXTipsSimple>
      </div>
    </div>
  </div>
</template>
